<template>
  <figure>
    <button
      v-if="slide.video || slide.isYouTube"
      :class="$style.videoSlide"
      :data-video-url="slide.video"
      :data-is-youtube="slide.isYouTube"
    >
      <i class="fab fa-youtube"></i>
      <img
        :src="slide.image"
        :alt="slide.title || ''"
        :width="slide.imageWidth"
        :height="slide.imageHeight"
      />
    </button>
    <a
      :href="slide.imageLink"
      :target="slide.newWindow ? '_blank' : '_self'"
      :class="$style.imageSlide"
      v-else
    >
      <img
        :src="slide.image"
        :alt="slide.title || ''"
        :width="slide.imageWidth"
        :height="slide.imageHeight"
      />
    </a>
    <figcaption :class="$style.figCaption" v-if="slide.title || slide.text">
      <h3 v-html="slide.title"></h3>
      <div :class="$style.captionText" v-html="slide.text"></div>
      <div :class="$style.textLink">
        <a
          v-if="slide.linkText"
          :href="slide.textLink"
          :target="slide.newWindow ? '_blank' : '_self'"
        >
          {{ slide.linkText }}
          <i class="fas fa-chevron-right" />
        </a>
      </div>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: "CarouselSlide",
  props: {
    slide: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style module lang="scss">
@import "./RotatingCarousel.scss";
</style>
